module.exports = __webpack_public_path__ + "static/media/Avenir-BlackOblique.e6244f91.woff2";